const EMAIL_REGEX = /[^\s@]+@[^\s@]+\.[^\s@]+/;

const URL_PROPERTY_KEYS = [
  '$current_url',
  '$referrer',
  '$initial_current_url',
  '$session_entry_url',
  '$pathname',
];

const RESERVED_PROPERTY_KEYS = ['$set', '$set_once', '$groups', '$group_set'];

export const stripQueryString = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  return value.split(/[?#]/)[0];
};

export const sanitizeEvent = (event) => {
  if (!event || !event.properties) {
    return event;
  }

  const properties = { ...event.properties };

  URL_PROPERTY_KEYS.forEach((key) => {
    if (typeof properties[key] === 'string') {
      properties[key] = stripQueryString(properties[key]);
    }
  });

  Object.keys(properties).forEach((key) => {
    if (RESERVED_PROPERTY_KEYS.includes(key)) {
      return;
    }

    const value = properties[key];
    if (typeof value === 'string' && EMAIL_REGEX.test(value)) {
      properties[key] = '<redacted>';
    }
  });

  return { ...event, properties };
};
